import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    accountSignInFailed, logoutProvider,
    logoutUser,
    patientTempLogin,
    patientTreatmentLogin,
    setScreenName
} from "../../store/actions/account.action";
import {StateParams} from "../../store/reducers";
import {saveLanguagePreference} from "../../store/actions/screenerQuestions.action";
import withPreferredLanguageSelection from "../home/withPreferredLanguageSelection";
import {MixpanelContext} from "../../analytics/Mixpanel";
import {clearAllData, setAppointmentId, setTreatmentId} from "../../store/actions/signup.action";

const SMS_LOGIN_SOURCE = "sms-treatment-link"
const TreatmentScreeningEntryScreen = () => {
    const analytics = React.useContext(MixpanelContext);
    const {
        patientId,
        treatmentId
    } = useParams();
    const {
        jwt,
        signInError,
    } = useSelector((state: StateParams) => state.account);
    const [invalidLink, setInvalidLink] = useState<boolean>(false);
    const [readyForScreening, setReadyForScreening] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setReadyForScreening(false)
        localStorage.removeItem("sj:patient-session-id")
        Object.keys(sessionStorage).filter(k => k.startsWith('pf_')).forEach(k => sessionStorage.removeItem(k))
        console.log("TSES: LOGOUT USER")
        dispatch(logoutUser())
        console.log("TSES: LOGOUT PROVIDER")
        dispatch(logoutProvider())
        console.log("TSES: CLEAR ALL DATA")
        dispatch(clearAllData())
    }, []);

    useEffect(() => {
        if (patientId && treatmentId) {
            console.log("TSES: setting treatmentId from query params")
            dispatch(patientTreatmentLogin({
                loginSource: SMS_LOGIN_SOURCE, treatmentId, patientId
            }));
            console.log("TSES: setting treatmentId in state ", treatmentId)
            dispatch(setTreatmentId({ treatmentId: treatmentId }))
            setReadyForScreening(true);
        } else {
            console.log("TSES: setting invalid link as true ")
            setInvalidLink(true);
        }
    }, [patientId, treatmentId]);

    useEffect( () => {
        console.log("TSES: JWT ")
        if (jwt && readyForScreening && !invalidLink) {
            console.log(`TSES: JWT ${jwt}`)
            // Wrap Mixpanel track event in a Promise with a fallback timeout
            const trackEvent = new Promise((resolve) => {
                analytics?.identify(patientId);
                analytics?.track("opened_treatment_screener_link_via_sms", { treatmentId, patientId }, resolve);
            });

            const timeout = new Promise((resolve) =>
                setTimeout(() => {
                    resolve(null);
                }, 500)
            );

            // Navigate to patient profile when either event tracking or timeout finishes
            Promise.race([trackEvent, timeout]).then(() => {
                console.log(`TSES: NAV to Patient PROFILE`)
                navigate('/patientProfile');
            });
        }
    }, [jwt, invalidLink, readyForScreening, analytics, patientId, treatmentId]);

    return (
        <div className={"static-full-screen"}>
            {
                (signInError || invalidLink) &&
                <h1>Treatment Link is invalid, please contact your Therapist</h1>
            }
        </div>
    );
}

export default TreatmentScreeningEntryScreen;
